// Should match the definitions in app/assets/scss/common/_settings.scss
// see http://foundation.zurb.com/sites/docs/v/5.5.3/media-queries.html
export const MOBILE_BREAKPOINT_PX = 631;
export const TABLET_BREAKPOINT_PX = 1024;
export const DESKTOP_BREAKPOINT_PX = 1200;
export const X_DESKTOP_BREAKPOINT_PX = 1440;

export const PAGINATION_PAGE_SIZE = 24;

export const SCORE_MESSAGES = [
  'VERY BAD',
  'BAD',
  'JUST OKAY',
  'GOOD',
  'VERY GOOD',
];

export const PARTICIPATE_FORM_STEPS = {
  intro: 'intro',
  revision: 'revision',
  upload: 'upload',
  info: 'info',
  complete: 'complete',
};

export const PARTICIPATE_FORM_FLOW = [
  PARTICIPATE_FORM_STEPS.intro,
  PARTICIPATE_FORM_STEPS.revision,
  PARTICIPATE_FORM_STEPS.upload,
  PARTICIPATE_FORM_STEPS.info,
  PARTICIPATE_FORM_STEPS.complete
];

export const PORTFOLIO_FORM_STEPS = {
  select: 'select',
  info: 'info',
};

export const PORTFOLIO_FORM_FLOW = [
  PORTFOLIO_FORM_STEPS.select,
  PORTFOLIO_FORM_STEPS.info
];

export const ENTRY_SCALE_LEVELS = 8;

export const BASE_64_REGEXP = /^data:image\/[^;]+;base64,/;
export const PAP14_URL_REGEXP = /start-a-project\/.*(brief|details|review|payment)/;
export const PAP0_1_1_URL_REGEXP = /start-a-project\/start-1-1/;
export const PROJECT_URL_REGEXP = /[A-Za-z0-9-]+-[0-9]+/;
export const PROJECT_ENTRIES_URL_REGEXP = /[A-Za-z0-9-]+-[0-9]+\/entries/;
export const PROJECT_WRAPUP_URL_REGEXP = /[A-Za-z0-9-]+-[0-9]+\/wrapup/;
export const PROJECT_FOCUS_GROUP_URL_REGEXP = /[A-Za-z0-9-]+-[0-9]+\/focus-groups/;
export const PROJECT_PRESENTATION_URL_REGEXP = /[A-Za-z0-9-]+-[0-9]+\/presentations/;
export const PROJECT_SETTINGS_URL_REGEXP = /[A-Za-z0-9-]+-[0-9]+\/settings/;
export const PROJECT_YOUR_ENTRIES_URL_REGEXP = /[A-Za-z0-9-]+-[0-9]+\/your-entries/;
export const EXPLORE_URL_REGEXP = /(explore)(\W)?$/;
export const EXPLORE_PROJECTS_URL_REGEXP = /explore/;
export const EXPLORE_CREATIVES_URL_REGEXP = /explore\/creatives/;
export const PROFILE_ENTRIES_URL_REGEXP = /^\/users\/(.)*\/(your-entries)\/[a-z]+/;

/* map password strength scores to labels */
export const PWD_SCORE_LABELS = ['very weak', 'weak', 'good', 'strong', 'very strong'];
/* minimum password strength required when setting a new password */
export const MINIMUM_PWD_SCORE = 3; // strong

/* admin views root URL */
export const ADMIN_ROOT = '/stefan';
export const ADMIN_REGEX = /^\/admin/;

/* error code returned when trying to retrieve a forbidden 1-1 project */
export const FORBIDDEN_1_1_CODE = 403010500;
/* error code returned when trying to retrieve a forbidden draft project */
export const FORBIDDEN_DRAFT_CODE = 403010600;
/* error code returned when trying to retrieve a forbidden deleted project */
export const FORBIDDEN_DELETED_CODE = 403010700;
/* error code returned when trying to retrieve a forbidden cancelled project */
export const FORBIDDEN_CANCELLED_CODE = 403010800;
/* error code returned when trying to retrieve a forbidden hidden project */
export const FORBIDDEN_HIDDEN_CODE = 403010900;

/* app assets */
export const assetMap = {
  development: '/assets',
  staging: 'https://s3.amazonaws.com/crowdspring3-assets/app-staging',
  production: 'https://s3.amazonaws.com/crowdspring3-assets/app',
};

export function getAssetsUrl() {
  const env = process.env.NODE_ENV || 'production';
  return assetMap[env];
}

/* default entry sorting used by the API (i.e. when no sorting is explicitly set) */
export const DEFAULT_API_ENTRY_SORTING = '-created_at';

/* the number below defines what are "enough" portfolio items for a creative */
export const PORTFOLIO_ITEM_COUNT_THRESHOLD = 5;



// WEBPACK FOOTER //
// ./common/variables.jsx